import { render } from "./AdminAccommodationsView.vue?vue&type=template&id=1a52e49e&ts=true&lang=pug"
import script from "./AdminAccommodationsView.vue?vue&type=script&lang=ts"
export * from "./AdminAccommodationsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__